<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          class="full-width"
          ><div slot="header">
            <strong>Create Access Rules</strong>
            <eb-button
              style="color:white; font-weight:bold;float: right;"
              text="Back"
              @click="e => $emit('created', e)"
            ></eb-button>
          </div>
          <ValidationObserver v-slot="{ invalid }">
            <form>
              <b-row>
                <b-col md="6">
                  <label for="planName">Name </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="planName"
                  >
                    <b-form-input
                      class=""
                      style="width: 75%;"
                      id="planName"
                      inputType="text"
                      v-model="inputObject.name"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="6">
                  <label for="keys">keys </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="keys"
                  >
                    <multiselect
                      v-model="inputObject.keys"
                      tag-placeholder="Add this as new keys"
                      placeholder="Select keys List"
                      label="name"
                      track-by="keys"
                      :options="permissions"
                      :multiple="true"
                      :taggable="false"
                      :open-direction="'bottom'"
                    ></multiselect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <hr />
              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-primary mr-4"
                  :disabled="invalid"
                  classic="mr-1 btn-primary"
                  text="Save"
                  @click.prevent="handleSubmit"
                >
                  Save
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver
} from "vee-validate/dist/vee-validate.esm";
import ebSelect from "@/components/FormElements/Select.vue";
import { listPermissions } from "@/services/auth";
import ebButton from "@/components/FormElements/Button";
import AccessruleDetails from "@/components/MasterSetup/accessrules/AccessruleDetails";
import {  mapGetters } from "vuex";

export default {
  name: "createfaq",
  components: {
    ebButton,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    AccessruleDetails
  },
  data: () => {
    return {
      show: true,
      inputObject: {
        name: "",
        keys: ""
      },
      permissions: []
    };
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID"
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    }
  },
  methods: {
    async handleSubmit() {
      let x = [];
      this.inputObject.keys.forEach(obj => {
        x.push(obj.keys);
      })
      let data={}
        data = {
          name: this.inputObject.name,
          keys: x
        };
      console.log(data);
      const response = await this.$store
        .dispatch("accessrule/createAccessrule", data).
        then((result) => {
          this.$swal({
            title: "Success",
            text: "Access Rule added successfully!!",
            type: "success"
          });
        });
       this.$emit("created", {});
      this.$store.dispatch(
        "accessrule/accessRuleList",
        this.$store.getters["auth/getUserID"]
      );
    }
  },
  async mounted() {
    try {
      const result = await listPermissions();
      this.permissions = result.response.map(d => {
        return {
          name: d.name,
          keys: d.name
        };
      });
    } catch (e) {
      this.$toasted.error(e.message);
    }
  }
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
</style>
